import  defines from './../api'
import {
    getCookie
  } from "@/utils/auth.js";


export function chkLogin() {
    let uid = getCookie('hdu');
    let hdt = getCookie('hdt');
    let ua = navigator.userAgent.toLowerCase();
    let loginurl  = defines.loginurl;
    let wechaturl = defines.wechaturl;
    let alipayurl = defines.alipayurl;
    let alipayoauth2url = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2017080308014832&scope=auth_user&redirect_uri=';
    let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx05d6a1410a2236e1&connect_redirect=1&redirect_uri=';  //正式环境
    // let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxaa2aa6cc330cd7bf&connect_redirect=1&redirect_uri='; //测试环境
    if(!!!uid || !!!hdt) {
     var currenturl = window.location.href;
     if(currenturl.indexOf('?') < 0) {
      currenturl += "?";
     } else {
      currenturl += "&";
     }
     if(ua.match(/MicroMessenger/i) == "micromessenger") {
      var redirectUrl = encodeURIComponent(wechaturl + currenturl);
      var resultUrl = oauth2url + redirectUrl + "&response_type=code&scope=snsapi_base&state=login#wechat_redirect";
      window.location.href = resultUrl;
     } else if(ua.indexOf("alipay") >= 0) {
      var redirectUrl = encodeURIComponent(alipayurl + currenturl);
      var resultUrl = alipayoauth2url + redirectUrl + "&scope=auth_user,auth_zhima";
      window.location.href = resultUrl;
     } else {
      window.location.href = loginurl + currenturl;
     }
    }
}



// WEBPACK FOOTER //
// ./src/api/login.js